import { setLocaleCookie } from "../utils/common";
import { useRouter } from "next/router";

interface IChangeLanguage {
  changeLanguage: (language: string) => any;
}

// 切换语言hooks
const useChangeLanguage = (): IChangeLanguage => {
  const router = useRouter();
  const { query, pathname, locale = "zh" } = router;

  if (typeof window !== "undefined") {
    document.dir = locale === "ar" ? "rtl" : "ltr";
  }

  /** 切换语言 */
  const changeLanguage = async (value: any): Promise<any> => {
    // void i18n.changeLanguage(value); // i18n 自定义字段国际化，需要中划线匹配语言包 zh-CN
    // langContext.changeAntdDayjsLang(value); // 针对antd和日期国际化 需要下划线来匹配对应语言包 zh_CN

    // 当用户再次访问网站时，它将使用这个 cookie 中指定的区域设置来重定向到正确的本地化位置，缓存7天
    setLocaleCookie(value);
    // 切换路由
    await router.push({ pathname, query }, router.asPath, {
      locale: value
      // scroll: false,
      // shallow: true,
    });

    // 替换url上针对语言的参数 tip:等待路由变化完成后再执行 URL 更新,Next.js 在路由变化时会进行一系列的生命周期事件触发，然后才更新页面的 URL。使用 router.push 触发路由变化会导致路由生命周期的改变，但是 URL 的实际更新可能稍有延迟
    // replaceUrlParam(value);
  };
  return { changeLanguage };
};

export default useChangeLanguage;
